import React, { useEffect, useRef, useState } from "react";

import RestartAltIcon from "@mui/icons-material/RestartAlt";
import {
    postAnswerFM
} from "../../util/resources";
const RechargeBar = ({
    counterScreen,
    thresholdTimer,
    userFeedback,
    breather,
    userPerformance,
    spaceKeyRef,
    completedTest,
    setUserFeedbackMsg,
    setUserPerformance,
    testPhrases,
    dataQuestion,
    setResetClicked,
    resetClicked,
    handleMeterValues,
    isExample
}) => {

    let currentMeterNumber = isExample ? 0 : Number(window.sessionStorage.getItem('currentMeterNumber'));
    let currentMeterValue = Number(window.sessionStorage.getItem('currentMeterValue'));
    const [progressVal, setProgressVal] = useState((currentMeterValue === 0 || isExample) ? userPerformance.totalMeterRefils[0]?.target : currentMeterValue);
    const [payload, setPayload] = useState({
        duration: 0,
        fwdtimes: 0,
        instrumentType: 1,
        pause: false,
        playTimes: 0,
        questions: [],
        rwdTimes: 0,
        currentMeter: 0,
        currentMeterVal: 0.0
    });
    const [metersFinished, setMetersFinished] = useState(false);
    let sessionId = window.sessionStorage.getItem("sessionId");
    let testId = window.sessionStorage.getItem("testId");
    const firstNotif = useRef({
        rechargeMeterNotifCount: 0,
    });
    const [userAnswer, setUserAnswer] = useState({
        answers: [],
        structure: null,
        value: "noRecharge",
    });
    function handleAnswerPost(payload, testId, sessionId) {
        if (!isExample) {
            postAnswerFM(testId, sessionId, payload).then((response) => {
                console.log('answer posted successfully for payload:', payload, ' with response: ', response);

            });
        }
    };

    const timerRef = useRef();
    const selectedMeterRefill = useRef(currentMeterNumber);
    if (userPerformance) {
        if (userPerformance.totalMeterRefils.length > 0) {
            if (userPerformance.totalMeterRefils[selectedMeterRefill.current].userAnswer) {
                setResetClicked(true);
            }
            else {
                setResetClicked(false);
            }
        }
    }
    const allowRefill = useRef(true);
    const selectedMeterVal = useRef(userPerformance.totalMeterRefils[currentMeterNumber]?.target)
    const examStarted = useRef(false)
    useEffect(() => {
        if (!counterScreen && !examStarted.current) {
            examStarted.current = true
            setProgressVal((currentMeterValue === 0 || isExample) ? userPerformance.totalMeterRefils[0]?.target : currentMeterValue);
            selectedMeterVal.current = userPerformance.totalMeterRefils[currentMeterNumber]?.target
            timerRef.current = setInterval(handleTimer, 100);
            return () => clearInterval(timerRef.current);
        } else if (!counterScreen && examStarted.current) {
            timerRef.current = setInterval(handleTimer, 100);
        }
    }, [counterScreen]);

    const handleUserResponse = () => {
        setResetClicked(true);
        if (progressVal > 0 && progressVal <= thresholdTimer) {
            setUserAnswer(prev => ({ ...prev, value: "perfectRecharge" }));
            payload.questions[0] = userPerformance.totalMeterRefils[selectedMeterRefill.current];
            userAnswer.value = 'pressed';
            payload.questions[0].userAnswer = userAnswer;
            payload.currentMeter = selectedMeterRefill.current + 1;
            handleAnswerPost(payload, testId, sessionId);
        } else if (progressVal > thresholdTimer) {
            setUserAnswer(prev => ({ ...prev, value: "earlyRecharge" }));
            payload.questions[0] = userPerformance.totalMeterRefils[selectedMeterRefill.current];
            userAnswer.value = 'not pressed';
            payload.questions[0].userAnswer = userAnswer;
            payload.currentMeter = selectedMeterRefill.current + 1;
            handleAnswerPost(payload, testId, sessionId);
        }
    }
    const handleTimer = (reset = false) => {
        if (reset && allowRefill.current) {
            if (userAnswer.value === "perfectRecharge") {
                handleMeterNotification("perfectRecharge");
            } else if (userAnswer.value === "earlyRecharge") {
                handleMeterNotification("earlyRecharge");
            }
        } else {
            setProgressVal((prev) => parseFloat(prev - 0.1).toFixed(1));
        }
    };

    const handleMeterNotification = () => {
        let selectedAnswer = userAnswer.value;
        if (selectedAnswer === "") {
            selectedAnswer = "noRecharge"
        }
        setUserAnswer(prev => ({ ...prev, value: "noRecharge" }));
        const shouldUpdateQuesPopup = false
        const shouldUpdateMeterPopup = firstNotif.current.rechargeMeterNotifCount === 0 && dataQuestion.feedback
        if (selectedAnswer === "perfectRecharge") {
            setUserPerformance((prev) => ({
                ...prev,
                correctMeterReset: prev.correctMeterReset + 1,
            }));
            setUserFeedbackMsg(shouldUpdateQuesPopup, shouldUpdateMeterPopup, 1, false, testPhrases['20023613'], testPhrases['20023614'])
            firstNotif.current.rechargeMeterNotifCount++;

        } else if (selectedAnswer === "earlyRecharge") {
            setUserFeedbackMsg(shouldUpdateQuesPopup, shouldUpdateMeterPopup, 2, false, testPhrases['20023615'], testPhrases['20023616'])
            firstNotif.current.rechargeMeterNotifCount++;

        } else if (selectedAnswer === "noRecharge") {
            setUserFeedbackMsg(shouldUpdateQuesPopup, shouldUpdateMeterPopup, 3, false, testPhrases['20023617'], testPhrases['20023618'])
            firstNotif.current.rechargeMeterNotifCount++;

        } else {
            setUserFeedbackMsg(shouldUpdateQuesPopup, shouldUpdateMeterPopup, 2, true, testPhrases['20023606'], testPhrases['20023620'])
            firstNotif.current.rechargeMeterNotifCount++;

        }
    };

    const handleMeterReset = () => {
        let userResponse = userAnswer.value;
        let resetType = 0;
        setUserAnswer(prev => ({ ...prev, value: "" }));
        if (userResponse === "perfectRecharge") {
            resetType = 1;
        }
        else {
            resetType = 0;
        }
        clearInterval(timerRef.current);
        if (
            selectedMeterRefill.current <
            userPerformance.totalMeterRefils.length - 1
        ) {
            setProgressVal(
                parseInt(userPerformance.totalMeterRefils[
                    selectedMeterRefill.current + 1
                ].target)
            );
            selectedMeterVal.current = parseInt(userPerformance.totalMeterRefils[
                selectedMeterRefill.current + 1
            ].target);
            handleMeterValues(0, selectedMeterRefill.current + 1);
            if (resetType === 0) {
                payload.questions[0] = userPerformance.totalMeterRefils[selectedMeterRefill.current];
                userAnswer.value = resetType === 1 ? 'pressed' : 'not pressed';
                payload.questions[0].userAnswer = userAnswer;
                payload.currentMeter = selectedMeterRefill.current + 1;
                handleAnswerPost(payload, testId, sessionId);
            }
            timerRef.current = setInterval(handleTimer, 100);
            selectedMeterRefill.current += 1;
        }
        else {
            setMetersFinished(true);
            if (resetType === 0) {
                payload.questions[0] = userPerformance.totalMeterRefils[selectedMeterRefill.current];
                userAnswer.value = resetType === 1 ? 'pressed' : 'not pressed';
                payload.questions[0].userAnswer = userAnswer;
                payload.currentMeter = selectedMeterRefill.current + 1;
                handleAnswerPost(payload, testId, sessionId);
            }
        }
    };
    useEffect(() => {
        if (userFeedback.show || breather || completedTest) {
            clearInterval(timerRef.current);
        } else if (!userFeedback.show && !counterScreen && !breather && !completedTest) {
            timerRef.current = setInterval(handleTimer, 100);
        }
    }, [userFeedback.show, breather, completedTest]);

    useEffect(() => {
        if (progressVal == 0) {
            clearInterval(timerRef.current);
            setResetClicked(false);
            handleMeterNotification("noRecharge");
            allowRefill.current = true;
            handleMeterReset();
        }
        else {
            handleMeterValues(progressVal, selectedMeterRefill.current);
        }
    }, [progressVal]);

    useEffect(() => {
        if (spaceKeyRef.current > 0) handleUserResponse(true)
    }, [spaceKeyRef.current])

    const progressLevel = {
        height: progressVal * (180 / selectedMeterVal.current),
        backgroundColor:
            progressVal <= thresholdTimer ? "rgb(218, 99, 99)" : null,
    };
    return (
        <div className="recharge-container">
            <div className="progress-container">
                <div
                    className="threshold-point"
                    style={{ bottom: `${thresholdTimer * (180 / selectedMeterVal.current)}px` }}
                />
                <div
                    className="progress-ind"
                    style={progressLevel}
                />
            </div>
            <div className="recharge-button-container">
                <button aria-label={testPhrases["20023612"]} className={(!resetClicked && !metersFinished) ? "recharge-button enabled-button" : "recharge-button disabled-button  recharge-button-selected"} id="recharge-button" onClick={() => handleUserResponse(true)} disabled={resetClicked} >
                    <RestartAltIcon />
                </button>
                <div className="test-phrase">{testPhrases["20023612"]}</div>
            </div>
        </div>
    );
};

export default RechargeBar;
